import { render, staticRenderFns } from "./SkeletonCardImage.vue?vue&type=template&id=2cdc5e39"
import script from "./SkeletonCardImage.vue?vue&type=script&lang=js"
export * from "./SkeletonCardImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports